import { WordImageUrlPair, WordType } from "../features/words/types";

export interface WordServiceOptions {
  limit?: number;
}

export interface WordImage {
  id: number;
  url: string;
  keyword?: string;
}

export abstract class WordService {
  abstract getWordsWhereFieldEquals(
    field: string,
    value: string,
    options?: WordServiceOptions
  ): Promise<WordType[]>;

  abstract getWordsWhereFieldLike(
    field: string,
    value: string,
    options?: WordServiceOptions
  ): Promise<WordType[]>;

  abstract getImagesForWords(
    words: string[]
  ): Promise<Record<string, WordImage[]>>;

  abstract getImagesForWord(word: string): Promise<WordImage[]>;

  abstract getRandomWordImagesPairs(): Promise<WordImageUrlPair[]>;
}
